import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import React from "react";
import { FormattedMessage } from "react-intl";

interface SelfExclusionMessageProps {
  hideForm: boolean;
  loading: boolean;
  handleConfirmSelfExclusion: Function;
  setHideForm: (hide: boolean) => void;
}

const SelfExclusionMessage: React.FC<SelfExclusionMessageProps> = ({
  hideForm,
  loading,
  handleConfirmSelfExclusion,
  setHideForm,
}) => {
  return (
    <div className={`self-exclusion__message ${hideForm ? "" : "hide"}`}>
      <FormattedMessage tagName="h3" id="settings-self-exclusion-warning" />
      <FormattedMessage
        tagName="span"
        id="settings-self-exclusion-message"
      />{" "}
      <a href="mailto:support@3et.com"> support@3et.com</a>
      <button
        id={"self-exclusion"}
        onClick={e => handleConfirmSelfExclusion(e)}
      >
        <FormattedMessage tagName="span" id="exchange-confirm" />
        {loading && <LoadingSpinner loading={loading} />}
      </button>
      <button className={"cancel__button"} onClick={() => setHideForm(false)}>
        <FormattedMessage tagName="span" id="registration-cancel" />
      </button>
      {/* Track self exclusion with Genius here */}
      <GeniusSiteTracking
        targetSelector="#self-exclusion"
        eventType="click"
        pageName="exclusion"
        value="accept"
      />
    </div>
  );
};

export default SelfExclusionMessage;
